var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "main" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isLoading,
            expression: "isLoading",
          },
        ],
      },
      [_c("v-page-loading")],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isLoading,
            expression: "!isLoading",
          },
        ],
      },
      [
        _c("v-page-header", { attrs: { title: _vm.getPageTile } }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hasLoadingError,
                expression: "hasLoadingError",
              },
            ],
          },
          [
            _c("div", { staticClass: "grid-container" }, [
              _c("p", { staticClass: "text-center" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.loadingError) +
                    "\n                "
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.hasLoadingError,
                expression: "!hasLoadingError",
              },
            ],
          },
          [
            _c("div", { staticClass: "grid-container" }, [
              _c("div", { staticClass: "grid-x" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "cell medium-9 medium-offset-1 large-11 large-offset-0",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "wrapper" },
                      [
                        _c("v-action-buttons", {
                          attrs: {
                            items: _vm.getActionButtons,
                            isDisabled: _vm.pmFormDisabled,
                          },
                          on: { actionClicked: _vm.onClickAction },
                        }),
                        _vm._v(" "),
                        _c("v-form-message", {
                          attrs: {
                            type: "error",
                            id: "form-error",
                            message: _vm.pmObjectError,
                          },
                          on: {
                            onClickAction: _vm.onClickActivateDialogAction,
                          },
                        }),
                        _vm._v(" "),
                        _c("v-form-message", {
                          attrs: {
                            type: "success",
                            id: "form-success",
                            message: _vm.pmObjectSuccess,
                          },
                          on: {
                            onClickAction: _vm.onClickActivateDialogAction,
                          },
                        }),
                        _vm._v(" "),
                        _c("v-form-message", {
                          attrs: {
                            type: "default",
                            id: "form-activate",
                            message: _vm.pmObjectActivate,
                            autoCloseTimeout: 0,
                            showActionButtons: true,
                          },
                          on: {
                            onClickAction: _vm.onClickActivateDialogAction,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "box" },
                          [
                            _c("v-navigation"),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c(
                                  "label",
                                  { attrs: { for: "form-field-salutation" } },
                                  [_vm._v(_vm._s(_vm.$t("form.account.title")))]
                                ),
                                _vm._v(" "),
                                _c("v-select-salutation", {
                                  attrs: {
                                    id: "form-field-salutation",
                                    isStatic: _vm.isViewMethod,
                                    placeholder: _vm.$t(
                                      "form.account.title.plc"
                                    ),
                                  },
                                  model: {
                                    value: _vm.pmObject.profile.salutation,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.pmObject.profile,
                                        "salutation",
                                        $$v
                                      )
                                    },
                                    expression: "pmObject.profile.salutation",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.isViewMethod
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group form-group--required",
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(_vm.$t("form.account.firstname"))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-control form-control--static",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              _vm.pmObject.profile.firstname
                                            ) +
                                            "\n                                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group form-group--required",
                                    class: {
                                      "form-group--error":
                                        _vm.$v.pmObject.profile.firstname
                                          .$error,
                                    },
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        attrs: { for: "form-field-firstname" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("form.account.firstname")
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.$v.pmObject.profile.firstname
                                              .$model,
                                          expression:
                                            "$v.pmObject.profile.firstname.$model",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        id: "form-field-firstname",
                                        name: "firstname",
                                        placeholder: _vm.$t(
                                          "form.account.firstname.plc"
                                        ),
                                      },
                                      domProps: {
                                        value:
                                          _vm.$v.pmObject.profile.firstname
                                            .$model,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.$v.pmObject.profile.firstname,
                                            "$model",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                ),
                            _vm._v(" "),
                            _vm.isViewMethod
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group form-group--required",
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(_vm.$t("form.account.lastname"))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-control form-control--static",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              _vm.pmObject.profile.lastname
                                            ) +
                                            "\n                                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group form-group--required",
                                    class: {
                                      "form-group--error":
                                        _vm.$v.pmObject.profile.lastname.$error,
                                    },
                                  },
                                  [
                                    _c(
                                      "label",
                                      { attrs: { for: "form-field-lastname" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("form.account.lastname")
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.$v.pmObject.profile.lastname
                                              .$model,
                                          expression:
                                            "$v.pmObject.profile.lastname.$model",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        id: "form-field-lastname",
                                        name: "lastname",
                                        placeholder: _vm.$t(
                                          "form.account.lastname.plc"
                                        ),
                                      },
                                      domProps: {
                                        value:
                                          _vm.$v.pmObject.profile.lastname
                                            .$model,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.$v.pmObject.profile.lastname,
                                            "$model",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                ),
                            _vm._v(" "),
                            _vm.isViewMethod
                              ? _c("div", { staticClass: "form-group" }, [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("form.phone"))),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-control form-control--static",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.pmObject.profile.communication
                                              .phone
                                          ) +
                                          "\n                                    "
                                      ),
                                    ]
                                  ),
                                ])
                              : _c("div", { staticClass: "form-group" }, [
                                  _c(
                                    "label",
                                    { attrs: { for: "form-field-phone" } },
                                    [_vm._v(_vm._s(_vm.$t("form.phone")))]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.pmObject.profile.communication
                                            .phone,
                                        expression:
                                          "pmObject.profile.communication.phone",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      id: "form-field-phone",
                                      name: "phone",
                                      placeholder: _vm.$t("form.phone.plc"),
                                    },
                                    domProps: {
                                      value:
                                        _vm.pmObject.profile.communication
                                          .phone,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.pmObject.profile.communication,
                                          "phone",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                            _vm._v(" "),
                            _vm.isViewMethod
                              ? _c("div", { staticClass: "form-group" }, [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("form.mobile"))),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-control form-control--static",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.pmObject.profile.communication
                                              .mobile
                                          ) +
                                          "\n                                    "
                                      ),
                                    ]
                                  ),
                                ])
                              : _c("div", { staticClass: "form-group" }, [
                                  _c(
                                    "label",
                                    { attrs: { for: "form-field-mobile" } },
                                    [_vm._v(_vm._s(_vm.$t("form.mobile")))]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.pmObject.profile.communication
                                            .mobile,
                                        expression:
                                          "pmObject.profile.communication.mobile",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      id: "form-field-mobile",
                                      name: "mobile",
                                      placeholder: _vm.$t("form.mobile.plc"),
                                    },
                                    domProps: {
                                      value:
                                        _vm.pmObject.profile.communication
                                          .mobile,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.pmObject.profile.communication,
                                          "mobile",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                            _vm._v(" "),
                            _vm.isViewMethod
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group form-group--required",
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(_vm._s(_vm.$t("form.email"))),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-control form-control--static",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              _vm.pmObject.profile.communication
                                                .email
                                            ) +
                                            "\n                                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group form-group--required",
                                    class: {
                                      "form-group--error":
                                        _vm.$v.pmObject.profile.communication
                                          .email.$error,
                                    },
                                  },
                                  [
                                    _c(
                                      "label",
                                      { attrs: { for: "form-field-email" } },
                                      [_vm._v(_vm._s(_vm.$t("form.email")))]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.$v.pmObject.profile
                                              .communication.email.$model,
                                          expression:
                                            "$v.pmObject.profile.communication.email.$model",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        id: "form-field-email",
                                        name: "email",
                                        placeholder: _vm.$t(
                                          "form.account.email.plc"
                                        ),
                                      },
                                      domProps: {
                                        value:
                                          _vm.$v.pmObject.profile.communication
                                            .email.$model,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.$v.pmObject.profile
                                              .communication.email,
                                            "$model",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "form-group form-group--required",
                                class: {
                                  "form-group--error":
                                    _vm.$v.pmObject.location_id.$error,
                                },
                              },
                              [
                                _c(
                                  "label",
                                  { attrs: { for: "form-field-location" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("form.project.location"))
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("v-select-location", {
                                  attrs: {
                                    id: "form-field-location",
                                    customerId: _vm.$route.params.customer,
                                    isStatic: _vm.isViewMethod,
                                    placeholder: _vm.$t(
                                      "form.project.location.plc"
                                    ),
                                  },
                                  model: {
                                    value: _vm.$v.pmObject.location_id.$model,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.$v.pmObject.location_id,
                                        "$model",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "$v.pmObject.location_id.$model",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c(
                                  "label",
                                  { attrs: { for: "form-field-usertype" } },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("form.account.permissions")
                                        )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("v-select-user-type", {
                                  attrs: {
                                    id: "form-field-usertype",
                                    isStatic: _vm.isViewMethod,
                                  },
                                  model: {
                                    value: _vm.pmObject.user_type_id,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.pmObject,
                                        "user_type_id",
                                        $$v
                                      )
                                    },
                                    expression: "pmObject.user_type_id",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }